import React, { FC } from 'react'
import { Grid, makeStyles } from 'transfix-ui/core'
import { IShipmentIssueDetailsFragment } from '../graphql/ShipmentIssueDetailsFragment'
import { useIssueRowColumns } from './utils'

interface IIssueRowProps {
  issue: IShipmentIssueDetailsFragment
  /**
   * Flag to show the reduced version of this component.
   * @example When the right-side panel is open, it will have fewer fields than usually does
   * @default false
   */
  reducedVersion?: boolean
}

const useIssueRowStyles = makeStyles(() => ({
  tableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
}))

export const IssueRow: FC<IIssueRowProps> = ({ issue, reducedVersion = false }) => {
  const classes = useIssueRowStyles()
  const columns = useIssueRowColumns(reducedVersion)

  return (
    <Grid container spacing={2} data-test={`issue-row-${issue.id}`}>
      {columns.map(({ getValue, key, weight }) => {
        return (
          <Grid item className={classes.tableCell} key={key} xs={weight}>
            {getValue(issue)}
          </Grid>
        )
      })}
    </Grid>
  )
}

export default IssueRow
